export default __webpack_public_path__ + "static/media/one.93655d4e.jpg";